//Reference: EN055

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class OriginWork extends Mappeable {

    idOriginPk: number;
    txtOrg: string;
    //mrkActive: boolean;
    isActive: string;

    constructor(o) {
        super(o);
        //this.mrkActive = this.mrkActive ??  false 
        this.isActive = this.isActive ??  "0" 
    }

    public mapToBack() {
        return {
            txtOrg: this.txtOrg,
            isActive: this.isActive ? 1 : 0,
        }
    }

}